import React from "react"
import classnames from "classnames"
import { IS_IE, IS_EDGE } from "AtomicUtils/environment"
import {
  VideoPlayer,
  HeroContent,
  Image,
} from "AtomicContainers"
import {
  Visible,
  Section
} from "AtomicComponents"
import longPolling from 'AtomicUtils/longPolling'


import styles from "./FullWidthImageSection.less"
import componentParser from "AtomicUtils/componentParser"

class FullWidthImageSection extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      polling: props.backgroundImageArray !== undefined,
      error: false,
      imageArrayIndex: 0,
      isIE: false
    }
  }

  componentDidMount(){
    const { backgroundImageArray } = this.props
    if (typeof backgroundImageArray !== undefined){
      longPolling({
        conditionFucntion: () => { return this.state.polling },
        callFunction: this._callEverySecond,
        errorFunction: () => this.setState({error:true}),
        interval: 3000
      })
    }

    setTimeout(() => {
      this.setState({
        isIE: IS_IE || IS_EDGE
      })
    }, 0)
  }

  componentWillUnmount(){
    this.setState({
      polling: false,
    })
  }

  _callEverySecond = () => {
    const { imageArrayIndex } = this.state
    let newImageArrayIndex = 0;
    const { backgroundImageArray } = this.props
    if (imageArrayIndex !== backgroundImageArray.length - 1) {
      newImageArrayIndex = imageArrayIndex + 1
    }else {
      newImageArrayIndex = 0;
    }

    this.setState({
      imageArrayIndex: newImageArrayIndex
    })
  }

  render() {
    let {
      backgroundImage,
      backgroundVideo,
      heading,
      mobileHeading,
      mobileBackgroundImage,
      backgroundImageArray,
      textVerticalAlign,
      textAlign='center',
      width,
      align,
      height,
      blurb,
      components,
      children,
      floating=false,
      wysiwygTheme='dark'
    } = this.props

    const { imageArrayIndex, isIE } = this.state

    if (!mobileBackgroundImage) mobileBackgroundImage = backgroundImage
    if (!mobileHeading) mobileHeading = heading

    let alignItems = 'center'
    if (textVerticalAlign === 'top') {
      alignItems = 'start'
    }
    if (textVerticalAlign === 'bottom') {
      alignItems = 'end'
    }

    let justifyContent = 'center'
    if (align === 'left') {
      justifyContent = 'left'
    }
    if (align === 'right') {
      justifyContent = 'right'
    }

    let minHeight = 'auto'
    if (height === 'widescreen') {
      minHeight = '60vw'
    }
    if (height === 'extra tall') {
      minHeight = '50vw'
    }
    if (height === 'tall') {
      minHeight = '40vw'
    }
    if (height === 'medium') {
      minHeight = '30vw'
    }
    if (height === 'compact') {
      minHeight = '20vw'
    }
    if (height === 'fit') {
      minHeight = 'auto'
    }

    // legacy
    if (wysiwygTheme === 'light') wysiwygTheme = 'dark'
    else if (wysiwygTheme === 'dark') {
      if (!backgroundImage && !backgroundVideo){
        wysiwygTheme = 'light'
      }
    }

    if (blurb && blurb.indexOf('#000000') > -1) {
      wysiwygTheme = 'light'
    }

    if (blurb && blurb.indexOf('text-align: left;') > -1) {
      textAlign = 'left'
    }
    return (
      <div className={classnames({
        [styles.FullWidthImageSection]: true,
        [styles.DarkTheme]: wysiwygTheme === 'dark',
        [styles.GreyThemeFloating]: floating,
      })}
        style={{
          alignItems: alignItems,
          justifyContent: justifyContent,
          flexDirection: justifyContent === 'right'? 'row-reverse' :'row',
          textAlign: textAlign,
          minHeight: minHeight,
          height: isIE && minHeight
        }}
      >
        <div className={classnames({
          [styles.FullWidthImageSectionContent]: true,
          [styles.FullWidth]: width === "full width",
          [styles.FullWidthLeftORRight]: align === "left" || align === 'right'
        })}>
          <Visible visible={["screen","tablet"]}>
            <Section horizontalPadding={align !== "center"}>
              { (heading || blurb) &&
                <HeroContent
                  textAlign={textAlign}
                  theme={wysiwygTheme}
                  heading={heading}
                  description={blurb} />
              }
              <div
                className={classnames({
                  [styles.ChildrenSection]: true,
                  [styles.ChildrenSectionCenter]: justifyContent === 'center',
                  })}
                  style={{
                    flexDirection: align != 'center' ? textAlign === 'right'? 'row-reverse' :'row' : 'column',
                    justifyContent: textAlign
                  }}
                  >
                {componentParser(components) || children}
              </div>
            </Section>
          </Visible>
          <Visible visible={["mobile"]}>
            <Section horizontalPadding>
              { (mobileHeading || blurb) &&
                <HeroContent
                  textAlign={textAlign}
                  theme={wysiwygTheme}
                  heading={mobileHeading}
                  description={blurb} />
              }
              <div
                className={classnames({
                  [styles.ChildrenSection]: true,
                  [styles.ChildrenSectionCenter]: justifyContent === 'center'
                  })}
                  >
                {componentParser(components) || children}
              </div>
            </Section>
          </Visible>
        </div>
        <div className={classnames({
          [styles.FullWidthImageSectionInside]: true
        })}>
          {backgroundVideo &&
            <VideoPlayer
              height={isIE ? "100%" : minHeight}
              calculatedHeight
              poster={backgroundImage}
              src={backgroundVideo}
            />
          }
          {!backgroundVideo && (backgroundImage || mobileBackgroundImage) &&
            <div className={classnames({
              [styles.FullWidthImageSectionAsset]: true,
              [styles.FloatingAsset]: floating,
            })}>
              <Visible visible={["screen","tablet"]}>
                {backgroundImage &&
                  <Image src={backgroundImage} height={200} />
                }
              </Visible>
              <Visible visible={["mobile"]}>
                {mobileBackgroundImage &&
                  <Image src={mobileBackgroundImage} height={200} />
                }
              </Visible>
            </div>
          }
          {backgroundImageArray &&
            <div className={classnames({
              [styles.FullWidthImageSectionAsset]: true
            })}>
              <Visible visible={["screen","tablet", "mobile"]}>
                {backgroundImageArray &&
                  <Image src={backgroundImageArray[imageArrayIndex].imageSrc} height={200} />
                }
              </Visible>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default FullWidthImageSection



// WEBPACK FOOTER //
// ./src/AtomicContainers/FullWidthImageSection/FullWidthImageSection.jsx